export function qS(node_or_selector, selector)
{
  if(typeof node_or_selector == 'string')
    return document.querySelector(node_or_selector);
  else
    return node_or_selector.querySelector(selector);
}

export function qSA(node_or_selector, selector)
{
  if(typeof node_or_selector == 'string')
    return Array.from(document.querySelectorAll(node_or_selector));
  else
    return Array.from(node_or_selector.querySelectorAll(selector));
}



// WEBPACK FOOTER //
// /opt/wh/whtree/~/dompack/extra/qsa.es